module.exports = __webpack_public_path__ + "img/legend-chart-category.6d86f7a5.svg";